import { formatDate } from "@/utils/formatDate";

function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

function daysAgo(d: Date, days: number): Date {
  const x = new Date(d);
  x.setDate(x.getDate() - days);
  return x;
}

const WEEKDAYS_PL = [
  "Niedziela",
  "Poniedziałek",
  "Wtorek",
  "Środa",
  "Czwartek",
  "Piątek",
  "Sobota",
];

export function labelForDay(iso: string): string {
  try {
    const d = new Date(iso);
    const now = new Date();
    if (isSameDay(d, now)) return "Dziś";
    if (isSameDay(d, daysAgo(now, 1))) return "Wczoraj";
    // Within the last 6 days → weekday name.
    for (let i = 2; i <= 6; i++) {
      if (isSameDay(d, daysAgo(now, i))) return WEEKDAYS_PL[d.getDay()];
    }
    return formatDate(d, "");
  } catch {
    return "";
  }
}

interface DateDividerProps {
  iso: string;
}

export function DateDivider({ iso }: DateDividerProps) {
  return (
    <div className="my-4 flex select-none items-center gap-3">
      <span className="h-px flex-1 bg-gray-200" />
      <span className="font-mono text-[10px] uppercase tracking-[0.12em] text-gray-400">
        {labelForDay(iso)}
      </span>
      <span className="h-px flex-1 bg-gray-200" />
    </div>
  );
}
